import { SERVICEDEFAULTYY } from "../yYindex";

//获取公司动态和行业咨询接口
export function getCDynamics(params) {
  return SERVICEDEFAULTYY({
    url: `/official-website/v1/content/page`,
    method: "post",
    data: params,
  });
}

//获取动态和咨询的详情
export function getDynamicsDetail(params) {
  return SERVICEDEFAULTYY({
    url: `/official-website/v1/content/get/${params}`,
    method: "get",
  });
}

// 留言提交接口
export function sendMessage(params) {
  return SERVICEDEFAULTYY({
    url: `/official-website/v1/message/send`,
    method: "post",
    data: params,
  });
}
